import React from 'react'
import PropTypes from 'prop-types'
import { Button } from 'shared/components'

import * as styles from './styles'

const PageSizeComponent = ({
  pageSizeControlRef,
  pageSize,
  pageSizeOptions,
  opened,
  onTriggerMenu,
  onRequestPageSizeChange,
}) => (
  <div ref={pageSizeControlRef} css={styles.container}>
    <Button plain css={styles.trigger} onClick={onTriggerMenu}>
      Show {pageSize}
    </Button>
    {opened && (
      <ul css={styles.optionsList}>
        {pageSizeOptions.map((size) => (
          <li
            key={size}
            data-size={size}
            css={styles.item}
            onClick={onRequestPageSizeChange}
          >
            {size}
          </li>
        ))}
      </ul>
    )}
  </div>
)

PageSizeComponent.propTypes = {
  pageSizeControlRef: PropTypes.shape(),
  opened: PropTypes.bool,
  pageSize: PropTypes.number,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  onTriggerMenu: PropTypes.func.isRequired,
  onRequestPageSizeChange: PropTypes.func.isRequired,
}

export default PageSizeComponent
